<script setup>
    import { onBeforeMount, ref } from 'vue';
    import FormSelect from '@/components/shared/form/FormSelect';
    import sensorsWatchListService from '@/services/sensorsWatchList.service';

    defineProps({
        modelValue: Object
    });

    const $emit = defineEmits(['update:modelValue']);

    const options = ref([]);

    const loadWatchlists = () => {
        sensorsWatchListService.getAll().then(watchList => {
            options.value = [
                { id: '', displayText: '-- All Watchlist --' },
                ...(watchList || []).map(w => ({ ...w, displayText: `${w.name} (${w.sensorIds?.length || 0})` }))
            ];
        });
    };

    const onChange = value => {
        const watchList = value ? options.value.find(op => op.id === +value) : null;
        $emit('update:modelValue', watchList);
    };

    onBeforeMount(() => loadWatchlists());

    defineExpose({ loadWatchlists });
</script>

<template>
    <FormSelect
        :modelValue="modelValue?.id || ''"
        @update:modelValue="value => onChange(value)"
        :options="options"
        valueField="id"
        textField="displayText"
    />
</template>
